import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../imgs/Logo.png';

const PrivateEvents: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan pt-28">
        <h1 className="text-4xl font-bold text-darkgreentext text-center">
          Private Events
        </h1>
        <div className="flex justify-center">
            <img src={Logo} alt="Motiv8 Logo" className="h-7/8 object-contain -mt-16 -mb-48"/>
        </div>

      <div className="max-w-4xl mx-auto px-8 py-16 text-center">
        <p className="text-xl text-darkgreentext leading-relaxed">
            Make your private event more impactful by bringing Sean in as an instructor with breathwork and/or explore the cold. 
            Private events are customizable so reach out to Sean to build an unforgettable experience.
        </p>
      </div>
      <div className="flex justify-center pb-8">
        <Link to="/contact" className="px-6 py-3 bg-darkgreentext text-white rounded-lg font-bold text-xl hover:bg-greenbutton transition">
          Contact Us Here!
        </Link>
      </div>
    </div>
  );
};

export default PrivateEvents;
